import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import breakpoints from "assets/theme/base/breakpoints";
import { Box } from "@mui/material";
import "./tabmodal1.css";
import useGetDevice from "../../../../hooks/useGetDevice";
import Modal from "@mui/material/Modal";
import LoyaltySectionModal from "../../loyaltySectionModal";
import { useDispatch } from "react-redux";
import { allProductsRenderType } from "../../../redux/Actions/paginationActions";

const TabmodalFirst = ({ setOpen, setRenderType }) => {
  const isMobile = useGetDevice();
  const lastElementRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [loyaltyModal, setLoyaltyModal] = useState(false);
  const [customerMobile, setCustomerMobile] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    setCustomerMobile(JSON.parse(localStorage.getItem("customer_details"))?.mobileNumber);
  }, [customerMobile]);

  const handleLoyaltyModal = () => {
    setLoyaltyModal(true);
  };

  const handleCloseModal = () => {
    setLoyaltyModal(false);
  };

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Tab") {
        const focusableElements = lastElementRef?.current?.querySelectorAll(
          'a, button, input, select, textarea, [tabIndex]:not([tabIndex="-1"])'
        );
        const firstElement = focusableElements?.[0];
        const lastElement = focusableElements?.[focusableElements.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  }, []);

  return pathname === "/grocery/cart" && isMobile ? (
    // <Box className="rewardContainer">
    //   <div className="rewardItem" onClick={() => navigate("/products/points")}>
    //     Loyalty points
    //   </div>
    //   <div className="rewardItem" onClick={() => navigate("/products/coupons")}>
    //     Coupons
    //   </div>
    // </Box>
    <></>
  ) : (
    <div className="customerContainer" tabIndex="1" ref={lastElementRef}>
      {/* <button className="customerDiv" disabled={true} >
      +New
    </button> */}
      <button
        disabled
        className="customerDiv disabled-opacity"
        id="myDiv2"
        onClick={handleLoyaltyModal}
      >
        Loyalty points{" "}
      </button>
      {/* <button className="customerDiv" disabled={true}>
      Gift vouchers
    </button> */}
      <button
        disabled
        className="customerDiv disabled-opacity"
        onClick={() => dispatch(allProductsRenderType("coupons"))}
      >
        Coupons
      </button>
      <button className="customerDiv" onClick={() => navigate("/products/offers")}>
        Offers
      </button>

      {loyaltyModal ? (
        <Modal open={loyaltyModal} onClose={handleCloseModal} sx={{ top: "30%", left: "40%" }}>
          <LoyaltySectionModal setLoyaltyModal={setLoyaltyModal} setOpen={setOpen} />
        </Modal>
      ) : null}
    </div>
  );
};

export default TabmodalFirst;